import React from 'react';
import { AnalyticsPageMeta } from 'features/analytics';
import { Remote } from '@okapi/remote';
import { Layout } from 'fronton-react';
import { BreadcrumbsSection } from 'features/breadcrumbs';
import { SeoDescriptionSection } from 'features/seo-description';
import { useEffectOnce } from '../../common/hooks/use-effect-once';
import { analyticsUtils } from '../../utils';
import { useSelector } from 'react-redux';
import { getIsAuthorized } from '../../common/selectors/all-cookies';
import { getIsMobileView, getPathname } from '../../common/selectors/location';

export const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const isAuthorized = useSelector(getIsAuthorized);
  const url = useSelector(getPathname);
  const isMobileView = useSelector(getIsMobileView);

  useEffectOnce(() => {
    const onPageLoad = () => {
      analyticsUtils.sendEvent('GA:pageview', {
        pagePath: url, // путь к странице
        userAuth: isAuthorized ? '1' : '0', // показатель авторизации
      });
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
    }
    return () => window.removeEventListener('load', onPageLoad);
  });

  return (
    <>
      <AnalyticsPageMeta />
      {!isMobileView && <Remote widget="header-footer/header" id="advice-header" fallback={<></>} />}
      {!isMobileView && (
        <Layout>
          <BreadcrumbsSection />
        </Layout>
      )}
      {children}
      <Layout>
        <SeoDescriptionSection />
      </Layout>
      {!isMobileView && <Remote widget="header-footer/footer" id="advice-footer" fallback={<></>} />}
    </>
  );
};
